import React from "react";
import {Svgs} from "@assets";
import styles from "./style.module.scss";
import {constant} from "@utils";
import moment from "moment";

export default function Component() {
  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <Svgs.Logo width={100} fill="black" />
        <div className={styles.textContainer}>
          <div className={styles.text1}>문의사항</div>
          <div className={styles.text2}>010-4661-2996</div>
          <div className={styles.text3}>홈페이지 관리자 42기 김홍엽</div>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.row}>
          <div>
            관리자 : <span className={styles.tablet}>42기 </span>김홍엽
          </div>
          <div className={styles.division}>|</div>
          <div>상호명 : 홍똘 에이전시</div>
          <div className={[styles.division, styles.tablet].join(" ")}>|</div>
          <div className={styles.tablet}>010-4661-2996</div>
        </div>
        <div className={styles.row}>
          <div>주소 : 경기도 광주시 문화로 29 3층</div>
          <div className={styles.division}>|</div>
          <div>사업자등록증 : 165-01-03280</div>
        </div>
        <div className={styles.row}>
          <div>개인정보보호책임자 : 김홍엽</div>
          <div className={styles.division}>|</div>
          <div>E-mail : hongddol@hongddol.com</div>
        </div>
        <div>
          <br />© 광주하남카네기 CEO클럽 총동문회 저작권 보유
        </div>
      </div>
      <div className={styles.btnContainer}>
        <div
          className={styles.btn}
          onClick={() =>
            window.open(
              "https://carnegieimages.s3.ap-northeast-2.amazonaws.com/policy/%E1%84%80%E1%85%A2%E1%84%8B%E1%85%B5%E1%86%AB%E1%84%8C%E1%85%A5%E1%86%BC%E1%84%87%E1%85%A9%E1%84%8E%E1%85%A5%E1%84%85%E1%85%B5%E1%84%87%E1%85%A1%E1%86%BC%E1%84%8E%E1%85%B5%E1%86%B7.pdf",
              "_blank",
            )
          }>
          개인정보처리방침
        </div>
      </div>
    </div>
  );
}
